// extracted by mini-css-extract-plugin
export default {"ClazzInput":"ClazzInput_ClazzInput__PyyxN","AutoCompleteText":"ClazzInput_AutoCompleteText__XoYhU"};